/**
 * Deliberately free of any three.js import. main.ts needs to decide whether
 * the 3D chunk is even worth fetching *before* fetching it - importing
 * anything from three.js here would defeat that, since the mere act of
 * importing pulls the whole library in.
 */

const SOFTWARE_RENDERER_PATTERN = /swiftshader|llvmpipe|software|basic render|microsoft basic/i;

export interface GpuCapabilities {
  webgl2: boolean;
  isMobile: boolean;
  isSoftwareRenderer: boolean;
}

function openProbeContext(): WebGL2RenderingContext | null {
  try {
    const canvas = document.createElement("canvas");
    return canvas.getContext("webgl2");
  } catch {
    return null;
  }
}

function isSoftwareRenderer(gl: WebGL2RenderingContext | null): boolean {
  if (!gl) return true;
  const info = gl.getExtension("WEBGL_debug_renderer_info");
  if (!info) return false; // can't introspect it - assume real hardware
  const renderer = String(gl.getParameter(info.UNMASKED_RENDERER_WEBGL));
  return SOFTWARE_RENDERER_PATTERN.test(renderer);
}

export function detectCapabilities(): GpuCapabilities {
  const gl = openProbeContext();
  const isMobile = window.matchMedia("(max-width: 719px)").matches || navigator.maxTouchPoints > 2;
  return {
    webgl2: !!(window.WebGL2RenderingContext && gl),
    isMobile,
    isSoftwareRenderer: isSoftwareRenderer(gl),
  };
}

export function prefersReducedMotion(): boolean {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
